module.exports = __webpack_public_path__ + "img/astro3.f27126cb.jpg";